import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { components } from "react-select";
import { Translate } from "../../Enums/Tranlate";

const CustomMenuList = (props) => {
	const { children, selectProps } = props;
	const menuListRef = useRef(null);
	const lang = useSelector((state) => state.auth.lang);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const scrollContainer = menuListRef.current;
		if (!scrollContainer) return;

		const handleScroll = async () => {
			const bottomReached =
				scrollContainer.scrollTop + scrollContainer.clientHeight >=
				scrollContainer.scrollHeight - 10;

			if (bottomReached && !loading && selectProps.onScrollToBottom) {
				setLoading(true);
				await selectProps.onScrollToBottom();
				setLoading(false);
			}
		};

		scrollContainer.addEventListener("scroll", handleScroll);
		return () => scrollContainer.removeEventListener("scroll", handleScroll);
	}, [loading, selectProps]);

	return (
		<components.MenuList {...props} innerRef={menuListRef}>
			{children}
			{loading && (
				<div style={{ padding: "12px 0", textAlign: "center" }}>
					{Translate[lang].loading} ...
				</div>
			)}
		</components.MenuList>
	);
};
export default CustomMenuList;
